import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CardDesignerCardElementPlaceholder from '../CardDesignerCardElementPlaceholder';

const propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  element: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
  }).isRequired,
};

const CardDesignerCardElementRectangle = ({ className, onClick, element }) => {
  const classes = classNames({
    'card-designer-card-element': true,
    'card-designer-card-element-rectangle': true,
    [className]: !!className,
  });

  const { cardElementConfiguration } = element;

  return (
    <a
      href="#"
      className={classes}
      onClick={event => {
        event.preventDefault();
        onClick();
      }}
    >
      <CardDesignerCardElementPlaceholder
        style={{
          backgroundColor: cardElementConfiguration.color,
        }}
      />
    </a>
  );
};

CardDesignerCardElementRectangle.propTypes = propTypes;

export default CardDesignerCardElementRectangle;
